// extracted by mini-css-extract-plugin
export default {"iconSuccess":"upload-successful-styles_iconSuccess__pvhgb","buttonSuccess":"upload-successful-styles_buttonSuccess__-AXai"};